<script setup lang="ts">
import type { ContentGridSectionRecord } from "~~/server/graphql/datocms/generated";

defineProps<{ data: ContentGridSectionRecord }>();
</script>

<template>
  <div class="mb-3xl lg:mb-5xl flex justify-center">
    <div class="w-full" :class="{ 'lg:w-3/5': !data.fullWidth }">
      <div
        class="grid grid-cols-1 gap-4" :class="{
          'sm:grid-cols-2': data.maxColumns >= 2,
          'md:grid-cols-3': data.maxColumns >= 3,
          'lg:grid-cols-4': data.maxColumns >= 4,
        }"
      >
        <StructuredContent
          v-for="contentSection in data.content" :key="contentSection.id" :data="contentSection.body"
          class="p-md bg-[#F3F1EC] [&_*:last-child]:mb-0" :class="{ 'md:p-xl': data.fullWidth }"
        />
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
